import { ADMINS, LEADERSHIP_VIEWERS, ROLES } from "../../constants/roles";
import { userHasAnyRole } from "../../utils/leadershipRoles";

const ROLE_TITLES = {
  [ROLES.CHAIRMAN]: "Chairman Dashboard",
  [ROLES.MD]: "Managing Director Dashboard",
  [ROLES.EXECUTIVE_DIRECTOR]: "Executive Director Dashboard",
  [ROLES.INVESTOR]: "Investor Dashboard",
};

export const DEFAULT_LEADERSHIP_TITLE = "Leadership Dashboard";

/**
 * Page title for the shared Leadership dashboard: the role's own name when the user holds exactly one of
 * the four leadership roles (and is no admin), "Leadership Dashboard" otherwise (several roles, or an
 * admin previewing the page).
 */
export function leadershipTitle(user) {
  if (userHasAnyRole(user, ADMINS)) return DEFAULT_LEADERSHIP_TITLE;

  const held = LEADERSHIP_VIEWERS.filter((role) => userHasAnyRole(user, [role]));
  return held.length === 1 ? ROLE_TITLES[held[0]] : DEFAULT_LEADERSHIP_TITLE;
}
